import { IWaitingResponse } from "./IWaitingResponse";

export const saveWaitingList = (payload: IWaitingResponse) => ({
  type: "SAVE_WAITING_LIST",
  payload,
});
